import React from 'react';
import {Select} from 'antd';

// Candidates are database-validated, version-pinned queries returned by the server.
export default function IntentResolution({result,onSelect}) {
    const resolution=result.resolution,candidates=resolution?.candidates || [];
    const key=query=>JSON.stringify([query.datasetVersion,query.unitId]);
    return <div className="rgnet-intent-resolution">
        <p>{resolution?.reason || '请选择匹配的基因。'}</p>
        {candidates.length>1&&<div className="rgnet-intent-unit-switch">
            <label htmlFor="rgnet-intent-unit">匹配疾病单元</label>
            <Select id="rgnet-intent-unit" aria-label="匹配疾病单元" showSearch optionFilterProp="label"
                value={key(result.query)} onChange={value=>{const candidate=candidates.find(row=>key(row.query)===value);if(candidate)onSelect(candidate.query);}}
                options={candidates.map(row=>({value:key(row.query),label:row.query.name || '未提供疾病名称'}))} />
        </div>}
    </div>;
}
